import { SpezzialPartnerMap } from './partner-map.ts';

if (!customElements.get('spezzial-partner-map')) {
  customElements.define('spezzial-partner-map', SpezzialPartnerMap);
}
